// removed by extract-text-webpack-plugin
module.exports = {"root":"Header__root___26tKq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Rules/Components/Header/Header.scss
// module id = 973
// module chunks = 0